import { GridColumn, GridColumns, mapGridColumns } from "@wcg/frontend-framework";


/*
* @NOTE: The main purpose of this function is to maintain the ordinal positions of unselected columns
* when updating the grid columns. It ensures that the original ordinal values of unselected columns
* are preserved in the final grid configuration. All the unselected columns are pushed to the end of the grid.
* */
export function mapUnselectedColumnOrdinal(ogGridColumns: GridColumns, updatedGridColList: GridColumns): GridColumns {
  if(!Object.entries(ogGridColumns).length || !Object.entries(updatedGridColList)?.length) {
    return {} as GridColumns;
  }

  const _filterColumns = Object.entries(ogGridColumns).reduce((acc, [key, value]) => {
    if(!updatedGridColList[key]) {
      acc[key] = {...value, }
    };
    return acc;
  }, {} as GridColumns);

  const _cols = {...updatedGridColList, ..._filterColumns};
  const _gridColumns: GridColumn[] = [];
  for (const column of Object.keys(_cols)) {
    _gridColumns.push(_cols[column]);
  }
  return mapGridColumns(_gridColumns);
}
